import { Backdrop } from "@mui/material";
import * as React from "react";
import { ReactSVG } from "react-svg";
import ServicesContext from "../../contexts/servicesContext";
import styles from './styles.scss';

interface IErrorDialogProps {
	headingText: string;
	descriptionText: string;
	onClose?: () => void
}

interface IErrorDialogState {
	isOpen: boolean
}

class ErrorDialog extends React.Component<IErrorDialogProps, IErrorDialogState> {
	static contextType = ServicesContext;
	context: React.ContextType<typeof ServicesContext>;

    constructor(props: any) {
        super(props);

		this.state = {
			isOpen: true,
		};

		this.handleClose = this.handleClose.bind(this);
	}

	handleClose(): void {
		this.setState({
			isOpen: false
		});
		if (this.props.onClose) {
			this.props.onClose();
		}
	}

    render(): any {
		return this.state.isOpen && <Backdrop style={{zIndex: 10300}}
			open={this.state.isOpen}>
			<div data-test='error-dialog' className={styles['container']}>
				<div className={styles['area-close']}>
					{
						this.props.onClose !== undefined &&
						<ReactSVG src={this.context.config.Icons.IconClose} className={`${styles['icon-close']}`} onClick={this.handleClose} />
					}
				</div>
				<h2>{this.props.headingText}</h2>
				{
					this.props.descriptionText &&
					<div className={styles['area-content']}>
						{this.props.descriptionText}
					</div>
				}
			</div>
		</Backdrop>;
    }
}

export default ErrorDialog;